<template lang="pug">
  ods-dropdown(
    :hide-on-click='false'
    icon='setting'
    @visible-change='handleVisibleChange')
    ods-dropdown-menu.popover-columns.desplegable(slot='dropdown')
      h3.titulosetting {{ $t('msg_generics.filter_table_menu') }}
      ods-dropdown-item(
        v-for='(column, index) in columns',
        :key='index')
        ods-checkbox(
          @input='handlerShowColumns(column)',
          v-model='column.show')
          | {{ column.text }}
</template>

<script>
export default {
  name: 'b2b-table-menu-commercial-relation',
  props: [],
  data () {
    return {
      columns: [],
      column: {}
    }
  },
  computed: {
    isShowBuyerNameCommercialRelation () {
      return this.$store.getters.isShowBuyerNameCommercialRelation
    },
    isShowSellerNameCommercialRelation () {
      return this.$store.getters.isShowSellerNameCommercialRelation
    },
    isShowChannelCommercialRelation () {
      return this.$store.getters.isShowChannelCommercialRelation
    }
  },

  methods: {
    handlerShowColumns (col) {
      console.log('handlerShowColumns en B2bTable: ', col)
      const column = col.value
      switch (column) {
        case 'comprador':
          this.$store.dispatch('isShowBuyerNameCommercialRelation', !this.$store.getters.isShowBuyerNameCommercialRelation)
          break
        case 'vendedor':
          this.$store.dispatch('isShowSellerNameCommercialRelation', !this.$store.getters.isShowSellerNameCommercialRelation)
          break
        case 'canal':
          this.$store.dispatch('isShowChannelCommercialRelation', !this.$store.getters.isShowChannelCommercialRelation)
          break
        default:
          break
      }
    },
    handleVisibleChange () {
      this.chargeFilters()
    },
    chargeFilters () {
      this.columns = [
        {
          text: this.$t('party_detail.channels.entity_table.sellers'), value: 'vendedor', show: this.isShowSellerNameCommercialRelation
        },
        {
          text: this.$t('party_detail.channels.entity_table.buyers'), value: 'comprador', show: this.isShowBuyerNameCommercialRelation
        },
        {
          text: this.$t('party_detail.channels.entity_table.channels'), value: 'canal', show: this.isShowChannelCommercialRelation
        }
      ]
    }
  },
  created () {
    this.chargeFilters()
  }
}
</script>

<style lang="scss" scoped>
.desplegable {
    top: 180px !important
}
.titulosetting {
      padding: 10px;
}
</style>
